
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import { Sale } from './types';
import StatisticsTrendsDetails from './StatisticsTrendsDetails.vue';
import Accordion from '@/components/ui/accordion/Accordion.vue';
@Component({
  components: { StatisticsTrendsDetails, Accordion }
})
export default class StatisticsTrendsSale extends Vue {
  @Prop({ type: Object as PropType<Sale>, default: () => {} })
  sale!: Sale;

  licenseValue: string = '';
  notLicenseValue: string = 'Bog';
  accordionExpanded: boolean = false;

  get labels(): string {
    return this.$attrs.template.labels;
  }

  get currentYear(): string {
    return this.$attrs.template.CurrentYear;
  }

  get previoustYear(): string {
    return this.$attrs.template.PreviousYear;
  }

  renderContent() {
    this.accordionExpanded = !this.accordionExpanded;
  }

  getLicenseValue(val: string) {
    this.licenseValue = val;
  }
}
